import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from '../../../share/ErrorMessage'

const TopicInfosEmptyGuard: WidgetGuard = ({ widgetId, children }) => {
  const { topicInfos } = useDashboardWidgetSetting(widgetId)
  const { t } = useTranslation()

  if (!topicInfos || topicInfos.length === 0)
    return <ErrorMessage>{t('topicInaccessible')}</ErrorMessage>

  return children
}

export default TopicInfosEmptyGuard
